import { useEffect, useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, Button, TextField } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { StyledStack, StyledTitle, ButtonContainer } from "./About.style";
import DrawerCM from "components/shared/Drawer";
import Toast from "helper/toast";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import { getaboutUsRequest, updateaboutUsRequest } from "api/requests";
import { privacySchema } from "validations";
import Editor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default function AddAbout() {
  const { request, loading } = useHttp();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  ////// editor ////////
  const [content, setContent] = useState("");
  const handleChange = (content) => {
    setContent(content);
  };

  const onSubmit = async (values) => {
    const res = await request({
      url: updateaboutUsRequest,
      values: { content },
    });

    if (res) {
      Toast({
        type: "success",
        title: "ویرایش درباره ما",
      });
    }
  };

  const getAboutUs = useCallback(async () => {
    let res = await request({
      url: () => getaboutUsRequest(),
    });
    setContent(res.text);

    if (res) {
      reset({
        text: res.text,
      });
    }
  }, [request, reset]);

  useEffect(() => {
    getAboutUs();
  }, [getAboutUs]);

  return (
    <DrawerCM title="درباره ما">
      {loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <StyledStack>
            <StyledTitle>درباره ما</StyledTitle>
            <Grid container>
              <Grid item xs={12} p={1.2}>
                {/* <TextField
                  id="text"
                  label="متن درباره ما"
                  variant="outlined"
                  multiline
                  rows={6.3}
                  fullWidth
                  required
                  {...register("text")}
                  error={Boolean(errors.text)}
                  helpertext={errors.text?.message}
                /> */}
                {content && (
                  <Editor
                    enableToolbar={true}
                    onChange={handleChange}
                    defaultValue={content}
                    setDefaultStyle="font-family: IranSans; height: 40vh;"
                    setOptions={{
                      buttonList: buttonList.complex,
                      font: [
                        "IranSans",
                        "IranSansBold",
                        "Arial",
                        "Impact",
                        "Tahoma",
                      ],
                    }}
                  />
                )}
              </Grid>

              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
